import { observer } from 'mobx-react';
import { Component } from 'react';
import { withOrderStore } from '../../context';
import PickupCurbsideInfo from './containers/PickupCarbsideInfo/PickupCarbsideInfo';
import PickupCustomerInfo from './containers/PickupCustomerInfo/PickupCustomerInfo';
import PickupRecipientInfo from './containers/PickupRecipientInfo/PickupRecipientInfo';
import { OrderStore } from '~/mobx/orderStore';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

// @ts-ignore
@withOrderStore
@observer
export default class OrderPickup extends Component<{ orderStore?: OrderStore }, {}> {
  get orderStore() {
    return this.props.orderStore!;
  }

  render() {
    return (
      <ScrollableBlock>
        <div className="d-flex flex-row mt-3">
          <div>
            {this.orderStore.order?.stranger_phone ? <PickupRecipientInfo /> : null}
            <PickupCustomerInfo />
          </div>
          {this.orderStore.order?.curbside ? <PickupCurbsideInfo /> : null}
        </div>
      </ScrollableBlock>
    );
  }
}
